/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from "react";
import useData from "./useData"; 
import CardTwo from "./CardTwo";
export default function CarruselHeader() {

  const refCarrusel = useRef();

  const { tecnologias } = useData();

  const [numItems, setNumItems] = useState(3);

  useEffect(() => {

    if (refCarrusel.current) {

      $(refCarrusel.current).owlCarousel({
        items: numItems,
        loop: true,
        margin: 5,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 2000,
        dots: false,
        nav: false,
        center: true
      });
    }

    // Función de limpieza: destruir el carrusel cuando el componente se desmonte
    return () => {
      if (refCarrusel.current) {
        $(refCarrusel.current).owlCarousel('destroy');
      }
    };

  }, [numItems]);

  // Responsive -------------
  const cambiarCantidad = (cantidad) => {
    setNumItems(cantidad);
    $(refCarrusel.current).trigger("refresh.owl.carousel"); // Refresca el carrusel
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        cambiarCantidad(3); // Cambia la cantidad de elementos
      } else {
        cambiarCantidad(1); // Reduce la cantidad de elementos en pantallas pequeñas
      }
    };

    // Ejecutar al montar el componente
    handleResize();

    // Agregar el evento de redimensionamiento
    window.addEventListener("resize", handleResize);

    // Cleanup: Eliminar el evento cuando el componente se desmonta
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div ref={refCarrusel} className="owl-carousel">
      {tecnologias.map((item, index) => {
        return <CardTwo key={index} item={item} />;
      })}
    </div>

  );
}
